<template>
  <BlokkliProvider v-if="node" v-bind="node.blokkliProps">
    <HeroImage v-if="node.mainImage" :hero-image="node.mainImage">
      <div class="absolute inset-0 flex items-end justify-center" />
    </HeroImage>

    <div class="border-b border-b-gray-200 mb-30">
      <ContentHeader :title="node.title!" :lead="node.lead" />
      <Container class="pb-30">
        <MenuOrganization
          v-if="node.organizationMenuChildren"
          :links="node.organizationMenuChildren"
        />
      </Container>
    </div>

    <BlokkliField :list="node.paragraphs" name="field_paragraphs" />
  </BlokkliProvider>
</template>

<script lang="ts" setup>
definePageMeta({
  name: 'home-bettingen',
  languageMapping: {
    de: '/bettingen',
  },
})

const { entity: node } = await useDrupalRouteQuery('organization_page')

useCDNHeaders((v) => v.addTags(['nuxt:page:homepage']))

await renderPageDependencies()
</script>

<script lang="ts">
export default {
  name: 'PageBettingen',
}
</script>
